import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {Card, Row, Col, Flex} from 'antd';
import {DoubleLine} from "./Labels";


export const IconBox = ({ IconComponent, color, padX=6, yScale=1}) => {
    return (
        <div style={{background: color, borderRadius: '8px', padding: `${4*yScale}px ${padX}px 7px ${padX}px`}}>
            <IconComponent sx={{ fontSize: 20, color: '#fff' }}/>

        </div>
    )
}

export const IconCard = ({ IconComponent, title, description, color, onClick }) => {

    return (
        <Card className={`gapless py-4 px-3 ${onClick && 'cursor'}`} onClick={onClick}>
            <Row gutter={16} align={'middle'} wrap={false}>
                <Col>
                    <IconBox IconComponent={IconComponent} color={color} />
                </Col>
                <Col>
                    <DoubleLine title={title} text={description} wrapText={false} />
                </Col>
            </Row>
        </Card>
    )

};


/**
 *
 * @param items {Array[Object]} - Array of objects with the following keys
 *                               Example:
 *                               [
 *                                  {
 *                                      IconComponent: AnalyticsOutlined,
 *                                      title: `${pageData.length} Pages`,
 *                                      description: "Total IQ Pages youve created",
 *                                      color: 'var(--green)'
 *                                  }...
 *                               ]
 *
 * @param space
 * @param width
 * @param center
 * @returns {JSX.Element}
 * @constructor
 */
const CardTabs = ({ items, space=16, width=320, justify='start', wrap=true })=>{
    return (
        <Row gutter={[space, space]} justify={justify} wrap={wrap}>
            {items.map((item, index) => (
                <Col style={{width}}>
                    <IconCard key={index} {...item} />

                </Col>
            ))}
        </Row>
    )
}

export default CardTabs;
